export default defineNuxtPlugin(() => {
  if (typeof window === "undefined") return;

  document.addEventListener("pointerdown", (e: PointerEvent) => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const target = (e.target as HTMLElement)?.closest(
      ".btn, .site-button, a.btn, a.button, [data-ink]"
    ) as HTMLElement | null;

    if (!target) return;
    if (target.hasAttribute("disabled") || target.getAttribute("aria-disabled") === "true") return;
    if (target.dataset.noInk === "true" || target.classList.contains("no-ink")) return;

    // Avoid double spawning if Button.vue handled it
    if (target.classList.contains("btn-ink")) return;

    const r = target.getBoundingClientRect();
    const blot = document.createElement("span");
    blot.className = "blot";
    const size = Math.max(r.width, r.height) * 2.4;
    blot.style.width = `${size}px`;
    blot.style.height = `${size}px`;

    const x = e.clientX || e.clientY ? e.clientX - r.left : r.width / 2;
    const y = e.clientX || e.clientY ? e.clientY - r.top : r.height / 2;

    blot.style.left = `${x}px`;
    blot.style.top = `${y}px`;

    target.appendChild(blot);
    blot.addEventListener("animationend", () => blot.remove());
  });
});
